import { useForm } from "react-hook-form";
import * as yup from "yup";
import { InputFormField } from "../common/formfields/InputFormField";
import { FormButtons } from "../common/forms/FormButtons";
import { FormHeader } from "../common/forms/FormHeader";
import styles from "../common/forms/forms.module.css";
import { CustomTypedEntityFormProps } from "../common/entity/EntityInterfaces";
import { CustomImport } from "../api/CustomImports";
import { yupResolver } from "@hookform/resolvers/yup";

export const CustomImportFormSchema = {
  name: yup.string().required("Instrument name is required").typeError("Instrument name is required"),
  method: yup.object().required("Method is required").typeError("Method is required"),
};

export const CustomImportForm = ({
  fieldLabels,
  permissions,
  title,
  subtitle,
  initialValues,
  onSubmit,
  onCancel,
  submitButtonLabel,
  loading,
  event,
  typeId,
}: CustomTypedEntityFormProps<"customImports">) => {
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, dirtyFields },
  } = useForm<Partial<CustomImport>>({
    defaultValues: initialValues,
    resolver: yupResolver(CustomImportFormSchema),
  });

  return (
    <>
      <FormHeader title={title} subtitle={subtitle} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        autoComplete="off"
        className={`form-horizontal ${styles.form_holder}`}
      >
        <fieldset>
          <legend className="col-md-offset-2 col-md-10">Details</legend>
        </fieldset>

        <InputFormField
          id="name"
          label={fieldLabels.name}
          errors={errors}
          register={register}
          autoFocus={true}
          required={true}
          placeholder="Enter instrument name..."
        />

        <FormButtons
          onClose={onCancel}
          onSubmit={handleSubmit(async (entity) => await onSubmit(entity))}
          submitButtonLabel={submitButtonLabel || "Save changes"}
          disabled={isSubmitting}
          errors={errors}
          loading={loading}
          reset={["EDIT", "CLONE"].includes(event) ? () => reset(initialValues) : undefined}
          dirtyFields={["EDIT", "CLONE"].includes(event) ? Object.keys(dirtyFields).length : undefined}
        />
      </form>
    </>
  );
};
